module.exports = __webpack_public_path__ + "img/eagle.dbe2584f.svg";